import React from 'react'
import { Divider, LayoutBand, Separator, useContainerWidth } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import NavLinks from './NavLinks'
import SocialSection from './SocialSection'

export default function FooterExpansionContent({ nonReligiousMode = true, canSeeTemple, external = false }) {
  const atWidth = useContainerWidth()
  const { t } = useTranslation()

  return (
    <>
      <LayoutBand marginX="lg" marginY="lg">
        <nav aria-label={t('nav.footer-links', 'Footer links')}>
          <NavLinks nonReligiousMode={nonReligiousMode} canSeeTemple={canSeeTemple} external={external} />
        </nav>
      </LayoutBand>
      <Divider fullWidth />
      <LayoutBand marginY="nano" marginX="lg">
        <Separator size={atWidth({ default: 'sm', sm: 'xs' })} />
        <SocialSection external={external} nonReligiousMode={nonReligiousMode} />
      </LayoutBand>
    </>
  )
}
